/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const Option = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.Option {...otherProps} className={className}>
      {children}
    </components.Option>
  );
};

Option.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

Option.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default Option;
